import { LazyLoadingSectionLogger, LoggingSection } from "@multiweb/logging";
import { IndexedDBPromise } from "../../IndexedDB/Promises/IndexedDBPromise";
import { IAttributeDescription, IAttributeDescriptionDbCache } from "../Remoting/Cache/ClassDescriptionCache/IAttributeDescription";
import { IndexedDbManager } from "./IndexedDbManager";

const logger = LazyLoadingSectionLogger.create(LoggingSection.indexedDB);

export class AttributeDescriptionDbManager extends IndexedDbManager {
    constructor(storageVersion: number = 1) {
        super("AttributesData", storageVersion);
        this.registerStore("OWRemoting.SWModelsDescriptionStorage");
    }

    protected override _getKeyPath(): string[] {
        return [ "className", "attrName" ];
    }

    public async getValues(className: string, attrNames: string[]): Promise<IAttributeDescriptionDbCache[]> {
        const values: any[] = attrNames.map((v) => [className, v]);

        const db = await this._storageDb;

        return IndexedDBPromise.getRowsByIndexValues(db, this._storeNames[0], values);
    }

    public async setValues(className: string, data: IAttributeDescription[]): Promise<void> {
        try {
            const db = await this._storageDb;
            const store = db.transaction(this._storeNames, "readwrite").objectStore(this._storeNames[0]);

            let excLogged = false;
            for (const li of data) {
                const cacheType = li.CacheType;
                delete li.CacheType;

                const dbLi: IAttributeDescriptionDbCache = {
                    attributeName: li.AttributeName,
                    cacheType: cacheType ? cacheType : "AttributeInfo",
                    className: className,
                    serializedObject: JSON.stringify(li),
                };

                try {
                    store.put(dbLi);
                } catch (e) {
                    if (!excLogged) {
                        logger.error(e);
                        excLogged = true;
                    }
                }
            }
        } catch (ex) {
            logger.error(ex);
        }
    }
}
